import requests from './httpService';

const AdminEventService = {
  getAllAdminEvent() {
    return requests.get(`/adminevent/list`);
  },
  getAdminEvent(body) {
    return requests.post('/adminevent/get', body);
  },
  createAdminEvent(body) {
    return requests.post('/adminevent/add', body);
  },
  getAdminEventById(id) {
    return requests.get(`/adminevent/public/${id}`);
  },
  deleteAdminEvent(body) {
    return requests.delete(`/adminevent/${body._id}`);
  },
  updateAdminEvent(body) {
    return requests.put(`/adminevent/${body._id}`, body);
  },
  addAllAdminEvent(body) {
    return requests.post('/adminevent/all', body);
  },
  uploadImage(body) {
    return requests.post('/upload/uploadimage', body);
  },
};

export default AdminEventService;

